module.exports = __webpack_public_path__ + "static/media/pexels-photo-755726.9f8bec90.jpg";